// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  // Also don't include modals
  // Also don't include skip to content link
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('[data-modal]')
  .not('[href="#page"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 160 // Offset the scroll by 160px so content isn't flush with viewport or hidden under sticky nav
        }, 300, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          // $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            // $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  // Get parameter from query string
function getUrlParameter(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

window.addEventListener('load', function() {
  if ( getUrlParameter('scrollOffset') == 'true' ) {
    var target = document.getElementById( getUrlParameter('scrollTarget') );
    var bodyRect = document.body.getBoundingClientRect();
    var elemRect = target.getBoundingClientRect();
    var offsetTop = elemRect.top - bodyRect.top;
    $('.content-toggle').removeClass('content-toggle--active');
    $('#' + getUrlParameter('scrollTarget') + ' .content-toggle').addClass('content-toggle--active');
    var headerAllowance = 85;
    if ( getUrlParameter( 'headerAllowance' ) !== null ) {
      var headerAllowance = getUrlParameter( 'headerAllowance' );
    }
    window.scrollTo(0, offsetTop - headerAllowance);
  }
})